import {
    FORNECEDOR_MODO_TELA,
    FORNECEDOR_SET_AGUARDANDO,
    FORNECEDOR_LISTADO
} from './fornecedorActions';

const INITIAL_STATE = {
    registro: {},
    modoTela: 'lista',
    aguardando: false,
    lista: [],
    listaSelect: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case FORNECEDOR_MODO_TELA:
            return {
                ...state,
                modoTela: action.payload.modo,
                registro: action.payload.registro || {}
            };

        case FORNECEDOR_SET_AGUARDANDO:
            return {
                ...state,
                aguardando: action.payload
            };

        case FORNECEDOR_LISTADO: {
            const lista = action.payload.data || [];

            return {
                ...state,
                lista,
                listaSelect: lista.map(item => ({
                    id: item.id,
                    valor: `${item.razao_social || ''}${item.cpf || item.cnpj ? ` - ${item.cpf || item.cnpj}` : ''}`
                }))
            };
        }

        default:
            return state;
    }
};